/** @jsx h */
import { h } from 'preact'
import clsx from 'clsx'
import { useGlobal } from '../use-global'

const Link = ({ href, className, children }) => {
  const [{ canvasConfig }] = useGlobal()

  return (
    <a
      href={href}
      className={clsx(`rcc-block rcc-uppercase rcc-underline rcc-text-xs rcc-text-center ${className}`, {
        'rcc-tracking-widest': canvasConfig.locale !== 'ar'
      })}
    >
      {children}
    </a>
  )
}

export default Link
